import { PermissionAccess, StaticFeatureEnum, PermissionVisibility } from '../../../../../manager/permission/permissions.types';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_PHYSIC_POSITION, WIZ_EVENT_TYPE, WizDateUtils } from '@wizeoo/akm-core-lib';
import { PopUpManager, WizIcon, WizLabel, WizPopUp, WizValidationContainerDirective, WizHgroup, WizVgroup, WizValidationError, WizDatasource, 
  WizEventManager, WizEvent, WizTranslationManager
 } from '@wizeoo/akm-component-lib';
import { Column, IHeaderParams } from 'ag-grid-community';
import { WidgetConfigurationObj, WidgetConfigurationItemObj, Measure } from '@wizeoo/akm-message-lib';
import { BaselineEngine, EM_ACTION, FIELD_KIND, FeiKeyDef, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';

import { UpdateRequest } from '../../../../../command/core/sync/sync.service';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { Model } from '../../../../../model/model';
import { PopUtils } from '../../../../../framework/components/pop/pop-utils';
import { IWidget, PivotCellEditPopData } from '../../../../../manager/widgets/i-widget';
import { ALK_EVENT_TYPE, WIDGET_KIND } from '../../../../../model/enums';
import { ViewData } from '../../../../../model/view.data';
import { FreedataValueVO } from  '../../../../../vo/core/freedatavalue.vo';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { PivotField } from '../../../../../manager/baselines/pivot-field.obj';
import { FilterMassRenderer } from './mass/filter-mass.renderer';
import { HeaderEditExtPop, widgetHeaderVO } from './header-editext.pop';
import { FreedataHeaderEditPop } from '../../../freedatas/pops/freedata-header-edit.pop';



@Component({
  selector: 'pivot-header-renderer',
  templateUrl: './pivot-header.renderer.html',
  styles: [':host {height:100%; width: 100%;}'],
})
export class PivotHeaderRenderer {
  @ViewChild('lbl', { read: WizLabel }) public lbl: WizLabel;
  @ViewChild('icoSettings', { read: WizIcon }) public icoSettings: WizIcon;
  @ViewChild('gpMass', { read: WizHgroup }) public gpMass: WizHgroup;
  @ViewChild('ddext', { read: FilterMassRenderer }) public ddext: FilterMassRenderer;


  public params: any;
  public colDef: any; // la colonne
  public popUpMode: WIDGET_KIND = WIDGET_KIND.GRID; // le mode de cette pop, pour alimenter les fkd
  public sortWay: number = 0; // ordre de tri, pour mémorisation globale
  public widget: IWidget = null;
  public fei: FeiVO = null;
  public model: Model = null;
  public field: string = null;
  public fkd: FeiKeyDef = null;
  public context: WidgetConfigurationObj = null; // le contexte complet du pivot
  public wcio: WidgetConfigurationItemObj = null; // le contexte de cette colonne
  public pivotField: PivotField = null; // pour gestion possible de n instances d'un même fkd

  public column: Column; // la colonne au sens Aggrid pour transmission sur les saisies en masse de filters

  public css: any = null;
  public fontColor = null;
  public backgroundColor = null;

  private fieldPop: WizPopUp; // la popUp d'édition

  public fdvDS: WizDatasource<FreedataValueVO> = new WizDatasource<FreedataValueVO>()
  .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
  .setFilter(this.fdvFilterFunc.bind(this))
  .setSelectionMode('single')
  .build();


  // filterFunc de la collection de fdv
  protected fdvFilterFunc(item: FreedataValueVO): boolean {

    if(item.deprecated) { // masquer les deprecated
      return false;
    }

    if(!!item.endDate && WizDateUtils.numberToDate(item.endDate) < WizDateUtils.TODAY) { // masquer les deprecated
      return false;
    }

    return true;
  }


  public textAlign = null; // alignement du texte

  public get arrowKind(): any {
    if (this.params.enableSorting && this.sortWay === 1) {
      return 'arrow-up';
    } else if (this.params.enableSorting && this.sortWay === -1) {
      return 'arrow-down';
    }
    return null;
  }

  constructor(public elementRef: ElementRef) {}

  // gets called once before the renderer is used
  agInit(params: IHeaderParams): void {
    // console.log('header agInit', params);
    this.params = params;
    this.column = params.column;
    this.colDef = params.column.getColDef();
    // console.log('colDef', this.colDef);
    this.widget = this.colDef.widget;
    this.wcio = this.colDef.wcio;

    if (this.widget?.pivotMode) {
      this.popUpMode = WIDGET_KIND.PIVOT;
    }
    this.fei = this.widget?.fei as FeiVO;
    this.model = this.widget?.model;
    this.field = this.colDef.field.split(ViewData.KEY_SEPARATOR)[0];
    this.context = this.widget?.context;


    this.fkd = this.colDef.fkd;

    this.pivotField = new PivotField(this.widget, this.wcio, this.fkd, null);
    
    this.pivotField.popUpMode = WIDGET_KIND.GRID;
    if (this.colDef.place === 'row') {
      this.pivotField.usedAsRow = true;
    } else { // data
      this.pivotField.usedAsData = true;
    }

    // couleur hérité conf grid
    try {
      const stylePartsH: string[] = this.widget.context.hsty?.split(ViewData.KEY_SEPARATOR);
      if(!!stylePartsH) {
        this.backgroundColor = stylePartsH[0];
        this.fontColor = stylePartsH[1];
      }
    } catch (e: any) {}

    // couleur custom
    try {
      const styleParts: string[] = this.pivotField.headerStyle.split(ViewData.KEY_SEPARATOR);
      let back: string = styleParts[0];
      if(back && back !== 'unset') {
        this.backgroundColor = back;
      }
      
      let font: string = styleParts[1];
      if(font && font !== 'unset') {
        this.fontColor = font;
      }
    } catch (e: any) {}

    // héritage du style de la colonne parente
    if(this.pivotField.headInherit) {
      // console.log('headInherit', this.pivotField, params);
      try {
        let daddy = params.column.getParent();
        if(daddy) {
          let daddyO = daddy.getOriginalColumnGroup();
          const styleParts: string[] = (daddyO.getColGroupDef() as any).style.split(ViewData.KEY_SEPARATOR);
          this.backgroundColor = styleParts[0];
          this.fontColor = styleParts[1];
          // console.log('headInherit style', this.backgroundColor, this.fontColor);
        }
      } catch(e: any) {

      }
    }

    switch(this.wcio?.heada) {
      case 'L':
        this.textAlign = 'left';
        break;
      case 'C':
        this.textAlign = 'center';
        break;
      case 'R':
        this.textAlign = 'right';
        break;
      default:
        try {
          this.textAlign =this.colDef?.cellClass?.split('-').pop();
        } catch(e: any) {
          this.textAlign = 'right';
        }
       
    }


    params.column.addEventListener('sortChanged', this.onSortChanged.bind(this)); // écouteur sur demande de changement d'ordre de tri
    this.onSortChanged(); // application

    this.manageMassUpdate();
  }

  // gets called whenever the cell refreshes
  refresh(params: IHeaderParams): false {

    // if(this.fkd?.code === 'AKM') {
    //   console.log('refresh', this.massValue, params);
    // }

    return false;
  }

  /** interception des demandes de sort sur le grid pour gestion custom */
  public onSortChanged() {
    if (this.params.column.isSortAscending()) {
      this.sortWay = 1;
    } else if (this.params.column.isSortDescending()) {
      this.sortWay = -1;
    } else {
      this.sortWay = 0;
    }
  }

  /** interception des demandes de sort sur le grid pour gestion custom */
  onSortRequested(event: any) {
    // console.log('onSortRequested', event);
    if(!this.params.enableSorting) {
      return;
    }

    let order: string = '';
    if (this.sortWay === 1) {
      // tri ascendant, on passe à ''
      order = '';
    } else if (this.sortWay === -1) {
      // tri descendant, on passe à ascendant
      order = 'asc';
    } else {
      // pas de tri, on passe à descendant
      order = 'desc';
    }

    let sortObj: any = { colId: this.params.column.colId, sortIndex: 0, sort: order,
      shift: event.shiftKey,
      params: this.params
     }; 
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.CUSTOM_SORT, sortObj));
  }

  /**
   * @override IWidget : ouverture de la popUp de configuration (clic sur l'icone de conf)
   * @param callback fonction de retour lors d'un appel délégué par le templateManager
   */
  public showSettingsPop(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();

    if (PopUpManager.exist(this.fieldPop)) {
      // suppression de l'instance existante
      this.fieldPop.hide();
    }

    let popFactory: any;
    if (this.widget.widgetKind === WIDGET_KIND.FD_GRID) {
      popFactory = FreedataHeaderEditPop;
    } else {
      popFactory = HeaderEditExtPop;
    }

    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.fieldPop = new WizPopUp(
      popFactory,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      HeaderEditExtPop.baseWidth + 'px',
      HeaderEditExtPop.baseHeight + 'px'
    );

    // alimentation des groupes sur le frid
    const preGroupArr: PivotField[] = [];
    this.context.g?.forEach((confItem: WidgetConfigurationItemObj) => {
      preGroupArr.push(this.model.widgetEngine.generateGroupEntry(this.widget, preGroupArr.length, confItem));
    });   

    // construction des données
    const datas: widgetHeaderVO = {
      popReference: this.fieldPop,
      fei: this.fei,
      context: this.widget.context,
      updateCallback: this.backFromPop.bind(this),
      pivotField: this.pivotField,
      popUpMode: this.popUpMode,
      widget: this.widget,
      place: this.colDef.place,
      actualWidth: this.params.column.actualWidth, // Largeur actuelle
    }
    // console.log(datas);
    // alimentation des datas
    this.fieldPop.datas = datas;

    const pos: DOMRect = this.icoSettings.elementRef.nativeElement.getBoundingClientRect();

    const bestXY: [number, number] = PopUtils.setPopCoord(pos, this.fieldPop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    // console.log('show', this.fieldPop.customPosition);
    if(bestXY[0] > 0 && bestXY[1] > 0) {
      this.fieldPop.customPosition = targetPosition;
    }
    
    this.fieldPop.show();
  }

  /**
   * modification de la construction du grid sur fermeture de pop
   * @param places[] [rows[], columns[], filters[], datas[],moreArg?: any]
   */
  public backFromPop(basecoll: any, pf: PivotField): void {
    
    let oldWcio: WidgetConfigurationItemObj = this.wcio;

    const candidates: WidgetConfigurationItemObj[] = this.context.r.concat(this.context.d);
    const candidate: WidgetConfigurationItemObj = candidates.filter((item) => item.ord === oldWcio.ord)[0]; // un seul
    candidate.sty = pf.style;
    candidate.hsty = pf.headerStyle;
    candidate.csty = pf.cellStyle;
    candidate.fmt = pf.format;
    
    candidate.fdvf = pf.fdvField;
    if(pf.fdvSubField) {
      candidate.fdvf = [pf.fdvField, pf.fdvSubField].join(WizConstants.FD_PARTS_SEPARATOR);
    }
    

    candidate.fdvSearch = pf.fdvSearch;
    candidate.lbl = pf.label;

    candidate.casiz = pf.colRezisable;
    candidate.cauto = pf.colAutoSize;
    candidate.cmsiz = pf.colMinSize;
    candidate.csiz = pf.colSize;
    candidate.ro = pf.readOnly;
    candidate.mems = pf.massSplit;

    candidate.heada = pf.headerAlign;
    candidate.cella = pf.cellAlign;

    if (this.widget.pivotMode) {
      candidate.agg = pf.wizAgregateFunc;
    } else {
      candidate.agg = null;
    }
    
    candidate.totAgg = pf.totalAgregateFunc;
    candidate.totAggM = pf.totalAgregateMeasure;
    candidate.totFmt = pf.totalFormat;
    
    candidate.exportable = pf.exportable;
    candidate.hiddenCol = pf.hiddenCol;
    candidate.headColorField = pf.headColorField;
    candidate.headSubField = pf.headSubField;
    candidate.headInherit = pf.headInherit;
    candidate.masterRowStyle = pf.styleConso;

    // reprise des settings workflow
    candidate.pmdexParams = pf.pmdexParams;
    // this.pivot.updateFieldContext(pivotField, this.wcio);
    this.widget.backFromSettingsPop(this.widget.context);
  }

  public get tooltipText(): any {
    if (this.fkd?.isMeasure) {
      const measCode: string = this.fkd.code;
      const measMode: string = this.fkd.mode;
      // const meas: MeasureVO = this.fei.getVisionStepVO().getMeasuresVOMap().get(measCode);
      // TODO TODO vérifier
      let meas: Measure =  BaselineEngine.getStepMeasureByCode(this.fei.vision, this.fei.visionStep, measCode);
      let mess: string = '';
      let parts: string[] = [];
      if(!!meas && (!meas.editable || measMode !== WizConstants.MEASURE_MODE_INTERACT) && !!this.params.enableMenu) {
        parts.push('<b>' + meas['formula' + measMode] + '</b>');
      }
      let desc: string = this.model.measureEngine.getMeasureDescription(meas);
      if(!!desc) {
        parts.push(desc);
      }
      if(parts.length > 0) {
        mess = parts.join('<br>');
      }

      return mess; // meas['formula' + measMode];
    }
    return '';
  }

  /** autorisation ou pas des tooltips sur le header (formule si measure calculée ou parce que tronqué) */
  public get tooltipEnable(): boolean {
    if (!!this.lbl && this.lbl.manageTooltip()) {
      // header tronqué, on affiche plutôt le libellé
      return false;
    } else {
      return this.fkd?.isMeasure; //  && this.params.enableMenu;
    }
  }

  /**
   * L'utilisateur a-t-il les droits pour modifier les templates ?
   */
  public get canUpdateTemplates(): boolean {
    if(!!this.model?.permissionEngine)
    {
        return this.model.permissionEngine.hasAnyPermission({
        accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
        feature: StaticFeatureEnum.TEMPLATE,
        visibility: PermissionVisibility.DISABLED
      });
    }
    return false;
  }





  /** Zone de validation des champs de saisie */
  @ViewChild('gpMass', { read: WizValidationContainerDirective, static: false })
  private gpMassValidator: WizValidationContainerDirective;
  @ViewChild('gpMain', { read: WizVgroup, static: false })
  private gpMain: WizVgroup;

  public showMassBoolean: boolean = false;
  public showMassNumber: boolean = false;
  public showMassText: boolean = false;
  public showMassDate: boolean = false;
  public showMassDrop: boolean = false;

  private _massValue: any = null;

  public get massValue(): any {
    // if(this.fkd?.code === 'AKM') {
    //   console.log('massValue pivotHeaderRenderer', this._massValue, this['eventWatcherId']);
    // }

    // if(!!this.colDef['massValue']) {
    //   this._massValue = this.colDef['massValue'];
    // }
    
    return this._massValue;
  }

  public set massValue(value: any) {
    // console.log('massValue pivotHeaderRenderer', this._massValue);
    this._massValue = value;
  }

  public wizMinNumber: number = null;
  public wizMaxNumber: number = null;
  public nbDecimal: number = 0;
  public wizMinDate: Date = null;
  public wizMaxDate: Date = null;
  public wizMaxChars: number = 50;
  public wizRestrict: string = null;


  private manageMassUpdate(): void {

    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateMassValue); // conf params
    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.CLEAR, this.clearMassValue); // conf params

    const meas: Measure = this.fkd?.measure;
    if (!!meas?.dataKind) {
      switch (meas.dataKind) {
        case FIELD_KIND.BOOLEAN:
          this.showMassBoolean = true;
          break;
        case FIELD_KIND.INT:
        case FIELD_KIND.NUMBER:
          this.showMassNumber = true;
          this.wizMinNumber = !!meas.minValue ? Number(meas.minValue) : null;
          this.wizMaxNumber = !!meas.maxValue ? Number(meas.maxValue) : null;
          this.nbDecimal = !!meas.nbDecimal ? meas.nbDecimal : 0;
          break;
        case FIELD_KIND.DATE:
          this.showMassDate = true;
          this.wizMinDate = !!meas.minValue ? WizDateUtils.stringToDate(meas.minValue) : null;
          this.wizMaxDate = !!meas.maxValue ? WizDateUtils.stringToDate(meas.maxValue) : null;
          break;
        case FIELD_KIND.STRING:
        case FIELD_KIND.COMMENT:
          this.wizMaxChars = !!meas.maxValue ? Number(meas.maxValue) : 50;
          this.showMassText = true;
          this.wizRestrict = !!meas.editRegex ? meas.editRegex : null; 
          break;
      }
    }
    else if(this.fkd?.isFilterKey) {
      this.showMassDrop = true;
    }
  } 

  private clearMassValue(e:WizEvent): void {
    // if(this.fkd.code === 'AKM') {
    //   console.log('clearMassValue', this.massValue, e);
    // }
    this.massValue = null;
  }

  // private lastKnowMassValue: any = null;

  private updateMassValue(e:WizEvent): void {
    
    if(this.showMassDate) {
      this.massValue = e.value ? WizDateUtils.dateToString(e.value) : null;
    } else {
      this.massValue = e.value || null;
    }

    // this.colDef['massValue'] = e.value;

    
  }


  /** mode saisie en masse autorisé */
  public get showMass(): boolean {
    return this.context?.eda && this.context?.hme && this.colDef?.editable;
  }


  public get disableMassValue(): boolean {
    if(!this.showMass) {
      return true;
    }
    
    if(this.widget?.mainDS?.selectedItems?.length <= 0) {
      return true;
    }

    return false;
  }

  public applyMass(e: any): void {
    // console.log('apply mass', e, this.massValue);
    let result: string = this.massValue?.toString() || null;
    
    const errors = this.gpMassValidator.check(true, true);
    if (errors?.length > 0) {
      errors.forEach((wve: WizValidationError) => {
        let mess: string = WizTranslationManager.getInstance().translateKey(wve.wizError, wve.wizErrorParams);
        WizPopUp.toast(mess, WizIcon.TOAST_ERROR).show();
      });
      return; // pas de changement
    }
    
    let datas: PivotCellEditPopData = { 
      kind: this.widget.widgetGlobalKind, pointer: null,
      title: null, 
      label: null, 
      value: result, 
      column: this.params.column,
      fkd: this.fkd, 
      line: null, 
      pack: this.widget.mainDS.selectedItems, 
      widget: this.widget,
      callback: null
    };
  

      let splitMode: boolean = false;
      // un number et mode split
      if(this.showMassNumber && !!this.wcio.mems) {
        splitMode = true;
      }

      let realLine: WidgetLine[] = [...this.widget.mainDS.selectedItems].filter( item => this.widget.mainFilterFunction(item)); 
      // console.log('applyMass check', this.widget.mainDS.selectedItems.length, realLine?.length);

      // la demande
      const updateRequest: UpdateRequest = {
        fei: this.fei, 
        line: null,
        lines: realLine, 
        operation: EM_ACTION.UPDATE,
        fkd: this.fkd,
        value: result,
        doSplit: splitMode,
      };

      datas.updates = updateRequest;
      this.widget.backFromEditPop(datas);


  }


}
